import { formatDate } from "@angular/common";
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators, } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";

@Component({
  selector: 'app-add-estimation-stage',

  templateUrl: './add-estimation-stage.component.html',
  styleUrl: './add-estimation-stage.component.css'
})
export class AddEstimationStageComponent {
  estimationForm !: FormGroup;
  locationForm!: FormGroup;
  clientForm!: FormGroup;
  selectedDomain = '';
  domainOptions:any = [];

  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: 'cost_per_housing_unit', label: 'Cost per Housing Unit', type: 'text', sampleValue: '₹ 1,200,000' },
      { key: 'landscaping_budget', label: 'Landscaping Budget', type: 'text', sampleValue: '₹ 500,000' },
      { key: 'interior_finish_grade', label: 'Interior Finish Grade', type: 'text', sampleValue: 'Premium' },
    ],
    Commercial: [
      { key: 'hvac_system_cost', label: 'HVAC System Cost', type: 'text', sampleValue: '₹ 2,500,000' },
      { key: 'elevator_installation', label: 'Elevator Installation', type: 'text', sampleValue: '₹ 1,800,000' },
      { key: 'fire_safety_equipment', label: 'Fire Safety Equipment', type: 'text', sampleValue: '₹ 1,000,000' },
    ],
    Educational: [
      { key: 'classroom_construction', label: 'Classroom Construction', type: 'text', sampleValue: '₹8,00,000 per unit' },
      { key: 'lab_equipment_budget', label: 'Lab Equipment Budget', type: 'text', sampleValue: '₹ 1,500,000' },
      { key: 'sports_infrastructure', label: 'Sports Infrastructure', type: 'text', sampleValue: '₹ 2,000,000' },
    ],
    Water: [
      { key: 'treatment_plant_cost', label: 'Treatment Plant Cost', type: 'text', sampleValue: '₹ 15,000,000' },
      { key: 'pipeline_installation', label: 'Pipeline Installation', type: 'text', sampleValue: '₹2,000/meter' },
      { key: 'pump_station_setup', label: 'Pump Station Setup', type: 'text', sampleValue: '₹ 3,000,000' },
    ],
    Power: [
      { key: 'transformer_procurement', label: 'Transformer Procurement', type: 'text', sampleValue: '₹ 4,000,000' },
      { key: 'cable_laying_cost', label: 'Cable Laying Cost', type: 'text', sampleValue: '₹1,200/meter' },
      { key: 'substation_setup', label: 'Substation Setup', type: 'text', sampleValue: '₹ 10,000,000' },
    ],
    Gas: [
      { key: 'pipeline_material_cost', label: 'Pipeline Material Cost', type: 'text', sampleValue: '₹1,500/meter' },
      { key: 'safety_equipment_budget', label: 'Safety Equipment Budget', type: 'text', sampleValue: '₹ 1,000,000' },
      { key: 'pressure_regulator_cost', label: 'Pressure Regulator Cost', type: 'text', sampleValue: '₹ 500,000' },
    ],
    Telecom: [
      { key: 'tower_construction_cost', label: 'Tower Construction Cost', type: 'text', sampleValue: '₹ 3,500,000' },
      { key: 'fiber_optic_cabling', label: 'Fiber Optic Cabling', type: 'text', sampleValue: '₹1,800/meter' },
      { key: 'signal_equipment_budget', label: 'Signal Equipment Budget', type: 'text', sampleValue: '₹ 2,000,000' },
    ],
    Road: [
      { key: 'asphalt_cost', label: 'Asphalt Cost', type: 'text', sampleValue: '₹3,000/ton' },
      { key: 'road_marking_budget', label: 'Road Marking Budget', type: 'text', sampleValue: '₹ 500,000' },
      { key: 'drainage_system_cost', label: 'Drainage System Cost', type: 'text', sampleValue: '₹ 1,200,000' },
    ],
    Consultancy: [
      { key: 'advisory_fee_structure', label: 'Advisory Fee Structure', type: 'text', sampleValue: '₹2,00,000/month' },
      { key: 'documentation_budget', label: 'Documentation Budget', type: 'text', sampleValue: '₹ 100,000' },
      { key: 'review_session_cost', label: 'Review Session Cost', type: 'text', sampleValue: '₹50,000/session' },
    ],
  };

  userD: any;
  organizationId: any;
  projectId: any;
  branchList: any;
  branchShow = false;
  allState: any
  allDistricts: any
  allSubDistricts: any
  allVillage: any;
  availableStates: any[] = [];
  availableCities: any[] = [];
  proShow = true
  projectList: any
  constructor(private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit(): void {
    const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId = this.userD.user.org_id;
    // this.fetchBranchList()
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];

    });
    if (this.projectId) {
      this.proShow = false
      this.getProjectChangeId()
    }
    this.estimationForm = this.fb.group({
      company_name: [this.userD.user.org_name, Validators.required],
      company_id: [this.userD.user.org_id, Validators.required],
      company_code: [this.userD.user.company_code, Validators.required],
      project_name: [''],
      project_id: [''],
      estimation_lead: [''],
      estimation_start_date: [''],
      estimation_end_date: [''],
      estimation_methodology: [''],
      cost_categories: [''],
      contingency_percentage: [''],
      currency_used: [''],
      estimation_document_ref: [''],
      domain: [''],
      stage: ['Estimation'],

    });
    this.locationForm = this.formBuilder.group({
      location: this.formBuilder.array([this.createLocationGroup()])
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];

    this.clientForm = this.formBuilder.group({
      client_name: ["", Validators.required],
      contact_person: ["", Validators.required],
      contact_number: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      khasra_no: ["", Validators.required],
      area: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      subDistrict: ["", Validators.required],
      villages: ["", Validators.required],
      client_id: [""],

    });
    this.patchData()
    this.fetchData()
    this.getstates()
  }
  fetchData() {
    this.apiService.getProjectplanning().subscribe({
      next: (res: any) => {
        console.log(res);
        this.projectList = res.data
        // this.dataSource.data = res.data;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }
  onProjectChange(selectedBranchId: any) {
    console.log(selectedBranchId);
    this.apiService.getProjectplanningId(selectedBranchId).subscribe({
      next: (reso: any) => {
        console.log(reso)
        const res = reso.data
        this.estimationForm.patchValue({
          project_name: res.project_name,
          project_id: res.project_id,
          estimation_lead: res.planning_lead,
          estimation_start_date: res.planning_start_date,
          estimation_end_date: res.planning_end_date,
          estimation_methodology: res.detailed_design,
          cost_categories: res.resource_allocation,
          contingency_percentage: res.contingency_percentage,
          currency_used: res.currency_used,
          estimation_document_ref: res.risk_assessment,
          domain: res.domain,


        });

        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          subDistrict: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id: client.client_id

        });


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }

        this.onDomainChange(this.estimationForm.value.domain)
         this.onDomainChange(this.estimationForm.value.domain)
        this.domainFields[this.estimationForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.estimationForm.get(field.key)?.patchValue(res[field.key]);
          }
        });

        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }
  getProjectChangeId() {
    this.apiService.getProjectestimationId(this.projectId).subscribe({
      next: (reso: any) => {
        console.log(reso)
        const res = reso.data
        this.estimationForm.patchValue({
          project_name: res.project_name,
          project_id: res.project_id,
          estimation_lead: res.estimation_lead,
          estimation_start_date: res.estimation_start_date,
          estimation_end_date: res.estimation_end_date,
          estimation_methodology: res.estimation_methodology,
          cost_categories: res.cost_categories,
          contingency_percentage: res.contingency_percentage,
          currency_used: res.currency_used,
          estimation_document_ref: res.estimation_document_ref,
          domain: res.domain,


        });

        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          subDistrict: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id: client.client_id

        });


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }

        this.onDomainChange(this.estimationForm.value.domain)
        this.domainFields[this.estimationForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.estimationForm.get(field.key)?.patchValue(res[field.key]);
          }
        });
        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }

  get location() {
    return this.locationForm.get('location') as FormArray;
  }

  createLocationGroup(): FormGroup {
    return this.formBuilder.group({
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      pincode: ['', Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });
  }

  addBranch() {
    this.location.push(this.createLocationGroup());
    const index = this.location.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  removeBranch(index: number) {
    if (this.location.length > 1) {
      this.location.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;

    Object.keys(this.estimationForm.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.estimationForm.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.estimationForm.addControl(field.key, this.fb.control(field.value));
    });
  }


  onSubmit(): void {
    if (this.projectId) {
      const formData = {
        ...this.estimationForm.value,
        ...this.locationForm.value,
        ...this.clientForm.value
      };
      this.apiService.updateProjectestimation(this.projectId, formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success("Project updated successfully");
          this.router.navigate(["/home/estimation-stage-list"]);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => '',
      });
    }
    else {
      if (this.estimationForm.valid) {
        const formData = {
          ...this.estimationForm.value,
          ...this.locationForm.value,
          ...this.clientForm.value
        };
        this.apiService.saveProjectestimation(formData).subscribe({
          next: (res) => {
            this.toastrMsgService.success("Project saved successfully");
            this.router.navigate(["/home/estimation-stage-list"]);
          },
          error: (err) => {
            this.toastrMsgService.error(err.error.errorMessage);
          },
          complete: () => '',
        });
      } else {
        this.estimationForm.markAllAsTouched();
      }

    }
  }

  patchData() {
    // this.estimationForm.patchValue({
    //   project_name: ['SigmaTConflux Infrastructure Project'],
    //   project_id: [12345],
    //   estimation_lead: ['Arvind Nair'],
    //   estimation_start_date: '2023-06-05',
    //   estimation_end_date: '2023-06-20',
    //   estimation_methodology: ['Bottom-up, Parametric'],
    //   cost_categories: ['Labor, Materials, Equipment'],
    //   contingency_percentage: [10],
    //   currency_used: ['INR'],
    //   estimation_document_ref: ['EST-2023-092'],
    //   domain: 'Residential',


    // });
    // this.onDomainChange(this.estimationForm.value.domain)
  }

  // fetchBranchList() {
  //   this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
  //     next: (res: any) => {
  //       if (res.data.length != 0) {
  //         this.branchList = res.data;;
  //         this.branchShow = true
  //       } else {
  //         this.estimationForm.get('companyName')?.setValue(this.userD.user.org_name);
  //         this.estimationForm.get('companyId')?.setValue(this.userD.user.org_id);
  //       }
  //     },
  //     error: (err) => {
  //       this.toastrMsgService.error(err.error.message);
  //     },
  //     complete: () => '',
  //   });
  // }
  onBranchChange(selectedBranchId: any) {
    const selectedBranch = this.branchList.find((b: { branch_id: any; }) => b.branch_id === selectedBranchId);
    const manager = selectedBranch?.primary_contact_name || '';
    this.estimationForm.get('branchId')?.setValue(manager);
  }

  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }

  onCountryBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
    branch.patchValue({ city: '' });
  }


  getstates() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.allState = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getdistricts() {
    const state = this.clientForm.value.state;
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.allDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getsubdistricts() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.allSubDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getvillages() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    const subdistrict = this.clientForm.value.subDistrict;
    this.apiService.getvillages(state, district, subdistrict).subscribe({
      next: (res) => {
        this.allVillage = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
}

